<template>
  <v-card>
    <v-card-text>
      <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Schüler, Klasse oder Fach suchen"
          single-line
          hide-details
          clearable/>
    </v-card-text>
    <v-data-table
        :headers="headers"
        :items="exams"
        :search="search"
        :custom-filter="filterExams"
        :loading="loading"
        :items-per-page="25"
        :footer-props="{itemsPerPageOptions: [25, 50, 100, -1], itemsPerPageText: 'Zeilen pro Seite'}"
        loading-text="Daten werden geladen..."
        :no-data-text="noDataText"
        no-results-text="Keine Treffer"
        class="elevation-1">
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | moment("DD.MM.YYYY") }}
      </template>
      <template v-slot:[`item.absence_type`]="{ item }">
        <v-chip small dark :color="absenceColour(item.absence_type)">
          {{ absenceLabel(item.absence_type) }}
        </v-chip>
      </template>
      <template v-slot:[`item.written`]="{ item }">
        <v-chip v-if="item.written" small dark color="green">Nachgeschrieben</v-chip>
        <v-chip v-else-if="!isExcused(item)" small outlined color="red">Nicht zugelassen</v-chip>
        <v-chip v-else small outlined>Offen</v-chip>
        <v-chip v-if="item.missed_retakes" small dark color="orange" class="ml-1">
          {{ item.missed_retakes }}× Termin verpasst
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import {accentInsensitiveTableFilter} from "@/core/utils/search";
import {ABSENCE_TYPES, isExcused, MissingExam} from "@/core/models/missing-exam";

@Component
export default class MissingExamTable extends Vue {
  @Prop({required: true}) readonly exams!: Array<MissingExam>
  @Prop({default: false}) readonly loading!: boolean
  @Prop({default: 'Keine versäumten Klausuren'}) readonly noDataText!: string

  private search = ''
  private filterExams = accentInsensitiveTableFilter
  private headers: Array<Record<string, any>> = [
    {text: 'Schüler', value: 'student_name'},
    {text: 'Klasse', value: 'class_name'},
    {text: 'Klausur', value: 'subject_name'},
    {text: 'Datum', value: 'date'},
    {text: 'Stunde', value: 'lessons', sortable: false},
    {text: 'Fehlzeit', value: 'absence_type'},
    {text: 'Status', value: 'written'},
  ]

  private isExcused = isExcused

  private absenceLabel(type: string): string {
    return ABSENCE_TYPES[type]?.label ?? type
  }

  private absenceColour(type: string): string {
    return ABSENCE_TYPES[type]?.colour ?? 'grey'
  }
}
</script>
